(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["re-inline-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('re-inline-product-video')) {
    customElements.define('re-inline-product-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.update = () => {
          if (this.visible && !document.hidden && !this.motion.matches) {
            this.video.play().catch(() => { /* Keep the poster if autoplay is blocked. */ });
          } else {
            this.video.pause();
          }
        };
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          this.update();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', this.update);
        this.motion.addEventListener('change', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.update);
        this.motion?.removeEventListener('change', this.update);
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
